var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloset({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m94.172 66.488-40.238-16.594v-12.219c4.4648-1.5703 7.6719-5.8281 7.6719-10.82-0.003907-6.3242-5.1484-11.469-11.469-11.469-6.3242 0-11.473 5.1445-11.473 11.469 0 2.0977 1.6992 3.7969 3.7969 3.7969 2.0977 0 3.7969-1.6992 3.7969-3.7969 0-2.1367 1.7383-3.8711 3.8711-3.8711 2.1328 0 3.8711 1.7383 3.8711 3.8711 0 2.1367-1.7383 3.8711-3.8711 3.8711-2.0977 0-3.7969 1.6992-3.7969 3.7969v15.258l-40.504 16.707c-3.543 1.4609-5.8281 4.8789-5.8281 8.707 0 5.1953 4.2266 9.418 9.418 9.418h40.312c0.089843 0 0.17969-0.003906 0.26953-0.007812 0.089844 0.007812 0.17969 0.007812 0.26953 0.007812h40.312c5.1953 0 9.418-4.2227 9.418-9.418 0-3.8281-2.2891-7.2461-5.8281-8.707zm-3.5898 10.531h-40.312c-0.089843 0-0.17969 0.003907-0.26953 0.007813-0.089844-0.007813-0.17969-0.007813-0.26953-0.007813h-40.312c-1.0039 0-1.8242-0.81641-1.8242-1.8242 0-0.74219 0.44141-1.4023 1.1289-1.6875l40.953-16.887h0.64844l40.949 16.887c0.6875 0.28516 1.1289 0.94531 1.1289 1.6875 0 1.0039-0.81641 1.8242-1.8203 1.8242z",
    fill: "#374336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloset);
export default __webpack_public_path__ + "static/media/closet.356913facd5579c1d6b359b646e3786e.svg";
export { ForwardRef as ReactComponent };